import * as z from "zod/v4";
import { portalCustomizationZodSchema } from "./get-portal-customization";

export const updatePortalCustomization = {
  name: "updatePortalCustomization" as const,
  input: z.object({ customization: portalCustomizationZodSchema }),
  output: z.object({ success: z.boolean() }),
};
